export function formatErrorValueExists(errorMessage: string, error: ApiError) {
  return errorMessage.replace(
    '[placeholder]',
    `${error.errorAttributes[0].rejectedValue}`
  )
}

export function formatErrorFaultyValues(
  options: FormatErrorFaultyValuesOptions
) {
  const { error, locale, messages, tariffParameters } = options

  const constraintElementName = error.errorAttributes[0].constraintElementName

  if (messages === null) return `${error.message}`

  if (
    tariffParameters &&
    constraintElementName.includes('tariff.inputParameters')
  ) {
    const messageId = 'dbc-error-registration-inputparam'

    const inputParamMessageRaw = `${messages[locale]![messageId]}`

    // https://stackoverflow.com/questions/1454913/regular-expression-to-find-a-string-included-between-two-characters-while-exclud
    const regex = /(?<=\[)(.*?)(?=\])/g

    const regExpMatchArray = constraintElementName.match(regex)

    if (regExpMatchArray === null) return `${error.message}`

    const index = parseInt(regExpMatchArray[0])

    const replacement = tariffParameters[index]!.name

    if (replacement === undefined) return `${error.message}`

    const inputParamMessage = inputParamMessageRaw.replace(
      '[placeholder]',
      replacement
    )

    return `${error.message} ${inputParamMessage}`
  }

  if (constraintElementName === 'mail') {
    const messageId = 'dbc-error-registration-company-email'

    return `${error.message} ${messages[locale]![messageId]}`
  }

  if (constraintElementName === 'mobile') {
    const messageId = 'dbc-error-registration-inputparam'

    const inputParamMessageRaw = `${messages[locale]![messageId]}`
    const inputParamMessage = inputParamMessageRaw.replace(
      '[placeholder]',
      `${messages[locale]!['dbc-label-mobile-phone']}`
    )

    return `${error.message} ${inputParamMessage}`
  }

  return error.message
}
